/**
 * @generated SignedSource<<37486dde2339c6f0854c6bb1453690cc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_issueViewLayoutTemplatesItemList_ItemList$data = {
  readonly fieldFragments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldId: string;
        readonly " $fragmentSpreads": FragmentRefs<"src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "src_issueViewLayoutTemplatesItemList_ItemList";
};
export type src_issueViewLayoutTemplatesItemList_ItemList$key = {
  readonly " $data"?: src_issueViewLayoutTemplatesItemList_ItemList$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_issueViewLayoutTemplatesItemList_ItemList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayCascadingSelectFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayGoalsFlag"
    }
  ],
  "kind": "Fragment",
  "name": "src_issueViewLayoutTemplatesItemList_ItemList",
  "selections": [
    {
      "alias": "fieldFragments",
      "concreteType": "JiraIssueFieldConnection",
      "kind": "LinkedField",
      "name": "fields",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueFieldEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "fieldId"
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "issueViewRelayCascadingSelectFlag",
                      "variableName": "issueViewRelayCascadingSelectFlag"
                    },
                    {
                      "kind": "Variable",
                      "name": "issueViewRelayGoalsFlag",
                      "variableName": "issueViewRelayGoalsFlag"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "f460cae6783f10f3173323300387c28c";

export default node;
